/**
 * @generated SignedSource<<9bbd808aa9a6f44411ffbe23fd48ac83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type ZnglyPostTypeEnum = "Catalog" | "Category" | "CrmList" | "Form" | "FormEntry" | "Hub" | "HubPage" | "MediaItem" | "SiteSettings" | "User" | "Znglist";
export type ReviewUsageQueryInput = {
  postIds: ReadonlyArray<string | null | undefined>;
  postType: ZnglyPostTypeEnum;
};
export type Review_Usage_Query$variables = {
  input: ReviewUsageQueryInput;
};
export type Review_Usage_Query$data = {
  readonly reviewUsage: {
    readonly results: ReadonlyArray<{
      readonly dependencies: ReadonlyArray<{
        readonly created: string | null | undefined;
        readonly depKey: string | null | undefined;
        readonly modified: string | null | undefined;
        readonly postType: ZnglyPostTypeEnum | null | undefined;
        readonly status: PostStatusEnum | null | undefined;
        readonly title: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly resKey: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type Review_Usage_Query = {
  response: Review_Usage_Query$data;
  variables: Review_Usage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ReviewUsage",
    "kind": "LinkedField",
    "name": "reviewUsage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReviewUsageResult",
        "kind": "LinkedField",
        "name": "results",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ReviewUsageDependency",
            "kind": "LinkedField",
            "name": "dependencies",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "depKey",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "created",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "modified",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Review_Usage_Query",
    "selections": (v1/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Review_Usage_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3cbf80e0c47cbbb697ded71b4d951a82",
    "id": null,
    "metadata": {},
    "name": "Review_Usage_Query",
    "operationKind": "query",
    "text": "query Review_Usage_Query(\n  $input: ReviewUsageQueryInput!\n) {\n  reviewUsage(input: $input) {\n    results {\n      resKey\n      dependencies {\n        depKey\n        postType\n        title\n        status\n        created\n        modified\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "31d8b4de915ab83681cf8ca6f6cca2dd";

export default node;
